module.exports = __webpack_public_path__ + "static/guard03-354447debb57d9ffdb2beb11f74eefd7.jpg";